export default __webpack_public_path__ + "449927b35ca0bb1118ec1c43377c3321.png";